<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:13:52
 * @LastEditors: luckymiaow
-->

<script lang="ts" setup>
import { Textarea as ATextarea } from 'ant-design-vue';
import { useAttrs, useSlots } from 'vue';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import type { InputBaseProps, InputInjectConfig } from '../types';
import useSlot from '../../hooks/useSlot';

const { getBindValue } = useForm<InputInjectConfig & InputBaseProps>({
  componentName: 'Textarea',
  attrs: useAttrs(),
});

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot v-if="readOnlySlot in $slots" :name="readOnlySlot" :text="getBindValue.value">{{ getBindValue.value }}</slot
    ><template v-else>{{ getBindValue.value }}</template></span
  >
  <a-textarea v-else v-bind="getBindValue">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </a-textarea>
</template>
